import { cn } from '@/lib/utils'

interface GuiaRepsolHacemosCocinaLogoProps {
    className?: string
}

/** Crisp typographic lockup. Treat as decorative; label via sibling text or a parent group. */
export function GuiaRepsolHacemosCocinaLogo({ className }: GuiaRepsolHacemosCocinaLogoProps) {
    return (
        <span
            className={cn(
                'inline-flex max-w-full flex-wrap items-center gap-x-[0.55em] gap-y-1 font-archivo text-[length:1em] leading-none text-current',
                className,
            )}
            aria-hidden
        >
            <span className='italic tracking-[-0.03em]'>guía repsol</span>
            <span className='h-[0.85em] w-px shrink-0 bg-current opacity-90' />
            <span className='font-semibold tracking-[-0.015em]'>Hacemos cocina</span>
        </span>
    )
}
